module.exports = __webpack_public_path__ + "static/media/contratoarrendamiento.4c19c430.svg";